import * as types from '../mutation-types'
// import * as constants from "../../mixins/constants"
import {
  getSubscriptionsList,
  getSubscriptionDetail,
  getMySubscriptionList,
  getMySubscriptionDetail,
  paymentSubscription,
  updateRenew
} from '@/store/api/user'

const state = {
  subscriptions_list: [],
  subscription_detail: [],
  my_subscription_list: {},
  my_subscription_detail: {},
  payment_methods_list: [],
  selected_subscription_plan: {},
  data_tracking: {}
}

const getters = {
  subscriptionsList: (state) => state.subscriptions_list,
  subscriptionDetail: (state) => state.subscription_detail,
  mySubscriptionList: (state) => state.my_subscription_list,
  mySubscriptionDetail: (state) => state.my_subscription_detail,
  selectedSubscriptionPlan: (state) => state.selected_subscription_plan,
  paymentMethodsList: (state) => state.payment_methods_list,
  dataTracking: (state) => state.data_tracking
}

const actions = {
  // eslint-disable-next-line
  getSubscriptionsList({ commit }, token) {
    return new Promise((resolve, reject) => {
      let param = {
        token: token
      }

      if (state.subscriptions_list && state.subscriptions_list.length !== 0) {
        return resolve(state.subscriptions_list)
      }

      getSubscriptionsList(param)
        .then((response) => {
          if (response) {
            resolve(response.body)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getSubscriptionDetail({ commit, rootGetters }, id) {
    return new Promise((resolve, reject) => {
      let params = {
        token: rootGetters.token,
        id: id
      }

      getSubscriptionDetail(params)
        .then((response) => {
          if (response) {
            commit(types.SET_SUBSCRIPTION_DETAIL, response.body)
            resolve(response.body)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getMySubscriptionList({ rootGetters }) {
    return new Promise((resolve, reject) => {
      let param = {
        token: rootGetters.token
      }
      try {
        const response = getMySubscriptionList(param)

        if (response) return resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  },

  getMySubscriptionDetail({ commit, rootGetters }, id) {
    return new Promise((resolve, reject) => {
      let params = {
        token: rootGetters.token,
        id: id
      }

      getMySubscriptionDetail(params)
        .then((response) => {
          if (response) {
            commit(types.SET_MY_SUBSCRIPTION_DETAIL, response.body)
            resolve(response.body)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // eslint-disable-next-line
  payment({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        const response = paymentSubscription(params)

        if (response) return resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  },

  // eslint-disable-next-line
  updateRenew({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        const response = updateRenew(params)
        if (response) return resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  },

  setSubscriptionsList({ commit }, data) {
    commit(types.SET_SUBSCRIPTIONS_LIST, data)
  },
  setSubscriptionDetail({ commit }, data) {
    commit(types.SET_SUBSCRIPTION_DETAIL, data)
  },
  setMySubscriptionList({ commit }, data) {
    commit(types.SET_MY_SUBSCRIPTION_LIST, data)
  },
  setMySubscriptionDetail({ commit }, data) {
    commit(types.SET_MY_SUBSCRIPTION_DETAIL, data)
  },
  setSelectedSubscriptionPlan({ commit }, data) {
    commit(types.SET_SELECTED_SUBCRIPTION_PLAN, data)
  },
  setPaymentMethodsList({ commit }, data) {
    commit(types.SET_PAYMENT_METHODS_LIST, data)
  },

  setDataTracking({ commit }, data) {
    commit(types.SET_DATA_TRACKING_SUBSCRIPTION, data)
  }
}

const mutations = {
  [types.SET_SUBSCRIPTIONS_LIST](state, data) {
    state.subscriptions_list = data
  },

  [types.SET_SUBSCRIPTION_DETAIL](state, data) {
    state.subscription_detail.push(data)
  },

  [types.SET_MY_SUBSCRIPTION_LIST](state, data) {
    state.my_subscription_list = data
  },

  [types.SET_MY_SUBSCRIPTION_DETAIL](state, data) {
    state.my_subscription_detail = data
  },

  [types.SET_SELECTED_SUBCRIPTION_PLAN](state, data) {
    state.selected_subscription_plan = data
  },

  [types.SET_PAYMENT_METHODS_LIST](state, data) {
    state.payment_methods_list = data
  },

  [types.SET_DATA_TRACKING_SUBSCRIPTION](state, data) {
    state.data_tracking = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
